import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { ClientsFetchAPI } from '../../api/Clients';
import { MailFetchAPI } from '../../api/Mail';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // <-- Importante
const ModalCreateNewClient = ({ getClients }) => {

    const [modalUserRegister, setModalUserRegister] = useState(false)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [nickNamel, setNickName] = useState('')
    const [password, setPassword] = useState('')
    const [Ruc, setRuc] = useState('')
    const [Dv, setDv] = useState('')
    const [passwordCheck, setPasswordCheck] = useState('')
    const [email, setEmail] = useState('')
    const [codeValidation, setCodeValidation] = useState(0)
    const [codeInput, setCodeInput] = useState(false)
    const [codeValidInput, setCodeValidInput] = useState('')
    // Estado para mostrar el resumen antes de registrar
    const [showSummary, setShowSummary] = useState(false);
    const [datavalidation, setDataValidation] = useState({})
    const [disabledRegister, setDisabledRegister] = useState(false)

    const cleanInputs = () => {
        setName('')
        setPhone('')
        setNickName('')
        setPassword('')
        setPasswordCheck('')
        setEmail('')
        setModalUserRegister(false)
        setShowSummary(false)
        setDataValidation({})
        setRuc('')
        setDv('')
    }

    const getClientType = async (dTipoRec) => {
        let token = localStorage.getItem('x-access-machine-token');
        try {
            const responseTypeClient = await ClientsFetchAPI.getClientType(token)
            console.log(responseTypeClient);
            let dataTypes = responseTypeClient.data.data;

            let dataNow = dataTypes.find(type => type.name.toLowerCase() == dTipoRec.toLowerCase())
            if (dataNow != undefined) { return dataNow.id } else { return 2 }
        } catch (err) {
            console.log(err);
            return 2;
        }
    }

    const authenticationDgi = async () => {
        setDisabledRegister(true)
        if (Ruc == "") {
            return {clientType:2};
        } else {
            let token = localStorage.getItem('x-access-machine-token');
            let data = { ruc: Ruc }
            try {
                const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
                setDisabledRegister(false)
                let dataDgi = response.data
                let dTipoRec = dataDgi?.dgi_response?.dTipoRec ? dataDgi.dgi_response.dTipoRec : "Consumidor final"
                let clientType = await getClientType(dTipoRec)
               

                if (dataDgi.dgi_response.gResProc) {
                    if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
                        let dvDgi = dataDgi.dgi_response.dDV
                        if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
                        setDataValidation({ billing_name: dataDgi.dgi_response.dNomb, dv: dvDgi, clientType: clientType, dTipoRec: dataDgi.dgi_response.dTipoRec, dTipoRuc: dataDgi.dgi_response.dTipoRuc })
                        return { clientType: clientType, billing_name: dataDgi.dgi_response.dNomb, dv: dvDgi };
                    } else {
                        setDataValidation({ clientType: 2})
                        setDv(0)
                        return { clientType: 2}
                    }
                }
            } catch (err) {
                setDisabledRegister(false)
                console.log(err);
                setDataValidation({ clientType: 2})
                setDv(0)
                return { clientType: 2}
           
            }
        }
    }



    const createClient = async () => {
        LoadingAlert('Creando usuario')
        let token = localStorage.getItem('x-access-machine-token')
        let business = JSON.parse(localStorage.getItem('business'))

        let authenticationDgi1 = datavalidation

          //setDataValidation({ billing_name: dataDgi.dgi_response.dNomb, dv: dvDgi, clientType: clientType, dTipoRec: dataDgi.dgi_response.dTipoRec, dTipoRuc: dataDgi.dgi_response.dTipoRuc })
                       
        let data = {
            name: name,
            billing_name: authenticationDgi1?.billing_name ? authenticationDgi1?.billing_name : name,
            phone: phone,
            email: email,
            password: password,
            ruc: Ruc,
            dv: authenticationDgi1?.dv ? authenticationDgi1?.dv : Dv,
            passwordCheck: passwordCheck,
            business_code: business.code,
            client_type_id: authenticationDgi1?.clientType ? authenticationDgi1?.clientType : 2,
            client_ruc_type: authenticationDgi1?.dTipoRuc ? authenticationDgi1?.dTipoRuc : 1,
        }

        try {
            const response = await ClientsFetchAPI.createClient(data, token)
            ErrorAlert('', 'Usuario creado con exito', 'success')
            getClients()
            cleanInputs()
        } catch (err) {
            setCodeInput(false)
            ErrorAlert('', err.response.data ? err.response.data.error : "Error al crear usuario", 'error')
            console.log(err)
        }
    }

    const sendMailValid = () => {
        let token = localStorage.getItem('x-access-machine-token')
        // Número aleatorio de 4 dígitos
        const random4Digits = Math.floor(1000 + Math.random() * 9000);
        setCodeValidation(random4Digits)
        let data = {
            "email": email,
            "subject": "Verificacion de correo",
            "text": "Correo de verificacion: " + random4Digits,
        }

        console.log(data);
        try {
            const response = MailFetchAPI.sendMail(data, token)
            ErrorAlert('', 'Correo enviado con exito', 'success')

        } catch (err) {
            setCodeInput(false)
            ErrorAlert('', err.response.data ? err.response.data.error : "Error al enviar correo", 'error')
            console.log(err)
        }
    }


    return (
        <>
            <button className='w-100 py-2 btn btn-outline-primary rounded-3' type="button" onClick={() => (setModalUserRegister(true))}>
                <i className="uil uil-user-plus"></i> Crear nuevo cliente
            </button>
            <Modal
                show={modalUserRegister}
                size="md"
                className='bg-blur-sp'
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className='row align-items-center'>
                        <div className="d-flex justify-content-center align-items-lg-center">
                            <div className="border-0 rounded-4">
                                <section className="form-signin-sp bg-white">
                                    <div className="d-flex justify-content-center border-bottom-0">
                                        <h2 className="modal-title fw-bold fs-5">
                                            <i className="uil uil-user-plus"></i> Nuevo cliente
                                        </h2>
                                    </div>
                                    <span className='p-0  text-primary fw-bold'>Formulario de clientes </span>
                                    <div className='pb-4'>
                                        {showSummary ? (
                                            <div className="border rounded-3 p-3 mb-3 bg-light">
                                                <h5 className="fw-bold text-primary mb-3">Confirmar datos del cliente</h5>
                                                <div className="mb-2">
                                                    <span className="fw-bold">Nombre:</span> {name}
                                                </div>
                                                <div className="mb-2">
                                                    <span className="fw-bold">Correo:</span> {email}
                                                </div>
                                                <div className="mb-2">
                                                    <span className="fw-bold">Teléfono:</span> {phone}
                                                </div>
                                                <div className="mb-2">
                                                    <span className="fw-bold">Nombre fiscal:</span> {datavalidation.billing_name ? datavalidation.billing_name : "Ruc no encontrado en la dgi"}
                                                </div>
                                                <div className="mb-2 d-flex align-items-center gap-2">
                                                    <span className="fw-bold">RUC:</span> {Ruc}
                                                    {Ruc && (
                                                        datavalidation.billing_name ?
                                                            <span className="badge bg-success-subtle text-success border border-success-subtle">Validado</span>
                                                            :
                                                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle">No validado</span>
                                                    )}
                                                </div>
                                                <div className="mb-2">
                                                    <span className="fw-bold">DV:</span> {datavalidation.dv ? datavalidation.dv: Dv}
                                                </div>
                                                {datavalidation.dTipoRec ?<>
                                                <div className="mb-2">
                                                    <span className="fw-bold">Tipo de cliente:</span> {datavalidation.dTipoRec ? datavalidation.dTipoRec : ""}
                                                </div>
                                                <div className="mb-2">
                                                    <span className="fw-bold">Tipo de RUC:</span> {datavalidation.dTipoRuc ? datavalidation.dTipoRuc : ""}
                                                </div>
                                                </>:<></>}
                                                <div className="d-flex justify-content-between mt-4">
                                                    <button className='btn bg-danger-subtle text-danger border-0 fw-bold' onClick={() => setShowSummary(false)}>
                                                        <i className="uil uil-times-circle"></i> Editar
                                                    </button>
                                                    <button className='btn bg-success-subtle text-success border-0 fw-bold' disabled={disabledRegister} onClick={createClient}>
                                                        <i className="uil uil-save"></i>{disabledRegister == false ? "Confirmar y Registrar":"Validando datos..."} 
                                                    </button>
                                                </div>
                                            </div>
                                        ) : codeInput == false ? <>
                                            <label className="form-label fw-bold text-black">
                                                <i className="uil uil-user-circle"></i> Nombre completo
                                            </label>
                                            <input type="text"
                                                className="form-control rounded-3 border-1 text-muted"
                                                placeholder="Ingresa tu nombre completo"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)} />

                                            {/*<label className="form-label fw-bold text-black mt-3">
                                                <i className="uil uil-user"></i> Nombre de usuario
                                            </label>
                                            <input type="text"
                                                className="form-control rounded-3 border-1 text-muted"
                                                placeholder="Nombre de usuario"
                                                onChange={(e) => setNickName(e.target.value)} />*/}

                                            <label className="form-label fw-bold text-black mt-3">
                                                <i className="uil uil-user"></i> Correo electrónico:
                                            </label>
                                            <input type="text"
                                                className="form-control rounded-3 border-1 text-muted"
                                                placeholder="Example@txt.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)} />



                                            <Form.Group className="mb-3 w-100" controlId="phone">
                                                <Form.Label>Teléfono</Form.Label>
                                                <PhoneInput
                                                    country={'pa'} // País inicial, puedes cambiarlo
                                                    value={phone}
                                                    onChange={phone => (setPhone(phone))}
                                                    inputProps={{
                                                        name: 'phone',
                                                        required: true,
                                                        autoFocus: true
                                                    }}
                                                    countryCodeEditable={false}
                                                    enableSearch
                                                />


                                            </Form.Group>
                                            <div className="col-md-12">
                                                <details className="mt-3">
                                                    <summary className="form-label fw-bold text-primary">
                                                        <i className="uil uil-edit"></i> RUC / DV
                                                    </summary>
                                                    <div className="row mt-2">
                                                        <div className="col-md-6">
                                                            <label className="form-label ">Número de RUC</label>
                                                            <input type="text"
                                                                className="form-control rounded-3 border-1 text-muted"
                                                                placeholder="0-0000-0"
                                                                value={Ruc}
                                                                onChange={(e) => setRuc(e.target.value)} /></div>
                                                        <div className="col-md-6">
                                                            <label className="form-label  mt-2">Número DV</label>
                                                            <input type="number"
                                                                className="form-control rounded-3 border-1 text-muted"
                                                                placeholder="00"
                                                                value={Dv}
                                                                onChange={(e) => setDv(e.target.value)} /></div>
                                                    </div>
                                                </details>
                                            </div>

                                            {/*<label className="form-label fw-bold text-black mt-3">
                                                <i className="uil uil-lock-alt"></i> Contraseña
                                            </label>
                                            <input type="password"
                                                className="form-control rounded-3 border-1 text-muted"
                                                placeholder="*********"
                                                onChange={(e) => setPassword(e.target.value)} />

                                            <label className="form-label fw-bold text-black mt-3">
                                                <i className="uil uil-lock"></i> Repetir contraseña
                                            </label>
                                            <input type="password"
                                                className="form-control rounded-3 border-1 text-muted"
                                                placeholder="*********"
                                                onChange={(e) => setPasswordCheck(e.target.value)} />

                                            <details className="mt-3">
                                                <summary className="form-label fw-bold text-primary">
                                                    <i className="uil uil-edit"></i> RUC / DV
                                                </summary>
                                                <div className="mt-2">
                                                    <label className="form-label text-black">Número de RUC</label>
                                                    <input type="text"
                                                        className="form-control rounded-3 border-1 text-muted"
                                                        placeholder="0-0000-0"
                                                        onChange={(e) => setRuc(e.target.value)} />

                                                    <label className="form-label text-black mt-2">Número DV</label>
                                                    <input type="number"
                                                        className="form-control rounded-3 border-1 text-muted"
                                                        placeholder="00"
                                                        onChange={(e) => setDv(e.target.value)} />
                                                </div>
                                            </details>*/}



                                            {/*<div className="d-flex justify-content-between mt-4">
                                                <button className="btn btn-danger rounded btn-sm  px-4" onClick={cleanInputs}>
                                                    Cancelar
                                                </button>
                                                <button className="btn btn-primary rounded btn-sm px-4" onClick={() => (sendMailValid(), setCodeInput(true))}>
                                                    Continuar
                                                </button>
                                            </div>*/}

                                            <div className="d-flex justify-content-between mt-4">
                                                <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                                    onClick={cleanInputs} >
                                                    <i className="uil uil-times-circle"></i>  Cancelar
                                                </button>
                                                <button className='btn bg-success-subtle text-success  border-0 fw-bold ' onClick={() => { authenticationDgi(); setShowSummary(true); }}>
                                                    <i className="uil uil-search"></i> Validar datos
                                                </button>
                                            </div>
                                        </> : <>
                                            <label className="form-label fw-bold text-black">
                                                <i class="uil uil-key-skeleton"></i> Ingresa el código de verificación
                                            </label>
                                            <input type="text"
                                                className="form-control rounded-3 border-1 text-muted"
                                                placeholder="0000"
                                                onChange={(e) => setCodeValidInput(e.target.value)} />

                                            <div className="d-flex justify-content-between mt-4">



                                                <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                                    onClick={() => setCodeInput(false)} >
                                                    <i class="uil uil-times-circle"></i>  Cancelar
                                                </button>
                                                <button className="btn btn-primary rounded btn-sm px-4" onClick={() => createClient()}>
                                                    Registrar
                                                </button>
                                            </div>

                                        </>}


                                    </div>
                                </section>
                            </div>
                        </div>

                    </div>


                    {/* <h2 className={'kiosk-delivery_title text-center text-success '}>
                        Registro de Usuario
                    </h2>
                    <div className='d-flex align-items-center justify-content-center'>
                        <div className="text-dark rounded-4 position-relative text-wrap bg-white   p-2">
                            <div className='d-flex'>
                                <Form>
                                    <Form.Group className="mb-3 kiosk-text-card" controlId="nickName">
                                        <span className="fw-bold">Ingresa nombre completo </span>
                                        <Form.Control className='kiosk-text-card border' type="text" placeholder="  Nombre" onChange={(e) => setName(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-3 kiosk-text-card" controlId="Name">
                                        <span className="fw-bold">Ingresa nombre de usuario </span>
                                        <Form.Control className='kiosk-text-card border' type="text" placeholder="nombre de usuario" onChange={(e) => setNickName(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-3 kiosk-text-card" controlId="Phone">
                                        <span className="fw-bold">Ingresa telefono </span>
                                        <Form.Control className='kiosk-text-card border' type="text" placeholder="6000-0000" onChange={(e) => setPhone(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-3 kiosk-text-card " controlId="exampleForm.ControlInput1">
                                        <span className="fw-bold">Ingresa la contraseña</span>
                                        <Form.Control className='kiosk-text-card border' type="password" placeholder="*********" onChange={(e) => setPassword(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-3 kiosk-text-card " controlId="exampleForm.ControlInput1">
                                        <span className="fw-bold">Ingresa la contraseña nuevamente</span>
                                        <Form.Control className='kiosk-text-card border' type="password" placeholder="*********" onChange={(e) => setPasswordCheck(e.target.value)} />
                                    </Form.Group>

                                    <div className='d-flex justify-content-center align-item-center'>
                                        <details className='' close>
                                            <summary className='sumamary-text bg-primary-subtle primary-success
                         p-1 rounded-3'><i class="uil uil-edit">Ruc / Dv</i>
                                                
                                            </summary>
                                            <div>
                                                <Form>
                                                    <div className='row d-flex justify-content-center align-item-center'>
                                                        <Form.Group className="mb-3 " controlId="formBasicText">
                                                            <Form.Label >Numero de Ruc</Form.Label>
                                                            <Form.Control placeholder="0-0000-0" onChange={(e) => (setRuc(e.target.value))} />
                                                        </Form.Group>

                                                        <Form.Group className="mb-3 " controlId="formBasicText">
                                                            <Form.Label >Numero DV</Form.Label>
                                                            <Form.Control type="number" placeholder="00" onChange={(e) => (setDv(e.target.value))} />
                                                        </Form.Group>
                                                    </div>
                                                </Form>
                                            </div>


                                        </details></div>


                                </Form>
                            </div>



                        </div>
                    </div>

                    <div className='d-flex justify-content-between '>
                        <button className={`m-1 btn btn-danger rounded btn-sm kiosk-subtitle-md position-relative px-4 `} onClick={() => (cleanInputs())}>
                            Cancelar
                        </button>
                        <button className={`m-1 btn btn-primary rounded btn-sm kiosk-subtitle-md position-relative px-4 `} onClick={() => createClient()}>
                            Registrar
                        </button>
                    </div> */}

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCreateNewClient